import {useSelector} from "react-redux";

export default function () {
    const metaOEmbed = useSelector(state => state.oEmbed.metaOEmbed);
    const loadingMetaOEmbed = useSelector(state => state.oEmbed.loadingMetaOEmbed);
    return { metaOEmbed, loadingMetaOEmbed };
}